<template>
  <div class="editor">
    <!-- <AppModalProfileSectionTitle>
      This is how you appear to other users.
    </AppModalProfileSectionTitle> -->
    <AppModalProfileHeader />
    <AppModalProfileRichTextEditor
      v-model="bioText"
      v-model:text-length="bioTextLength"
      edit-label="Click to Edit Your Bio"
      :class="{inactive: isAnyOpen}"
      :is-editing="isBioEditing"
      :max-length="800"
      :placeholder="PLACEHOLDER"
      :disabled="isLoading || isSaving || isAnyOpen"
      @start="startBioEditing"
      @cancel="discardBioEdits"
    />
  </div>
</template>

<script setup>
import AppModalProfileHeader from "@/components/App/Modal/Profile/ProfileHeader";
// import AppModalProfileSectionTitle from "@/components/App/Modal/Profile/SectionTitle";
import AppModalProfileRichTextEditor from "@/components/App/Modal/Profile/RichTextEditor";
import {useProfileContent} from "@/composables/useProfileContent";
import {useProfileFieldEdits} from "@/composables/useProfileFieldEdits";

const {
  bioText, bioTextLength, isLoading, isSaving, isBioEditing, startBioEditing, discardBioEdits
} = useProfileContent();
const {isAnyOpen} = useProfileFieldEdits(); // a profile field is open: the bio card is inactive
const PLACEHOLDER = "Introduce yourself to the VIZBI community.\n\n" +
  "Write in the first person, max 800 characters.";

defineExpose({focus: startBioEditing});
</script>

<style scoped>
.editor {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0 0 3px; /* closer to the footer buttons */
}
/* the bio card takes the height left (index.vue .page.fills) */
.editor > .bio {
  flex: 1;
  min-height: 0;
}
/* a homepage, LinkedIn or affiliation edit is open: muted, not editable, not selectable */
.inactive {
  opacity: 0.45;
  pointer-events: none;
  user-select: none;
}
</style>
